import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import LinearProgress from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";

const CustomProgressDialog = ({ open, text }) => {
  // State to manage the visibility of the dialog
  const [dialogOpen, setDialogOpen] = useState(open);

  useEffect(() => {
    setDialogOpen(open);
  }, [open]);

  // Function to handle closing the dialog
  const handleClose = () => {
    setDialogOpen(false);
  };

  // Prevent clicks on the progress indicator itself from affecting the loading state
  const handleProgressClick = (event) => {
    event.stopPropagation();
  };

  return (
    <div onClick={handleProgressClick}>
      <Dialog
        open={dialogOpen}
        onClose={handleClose}
        disableEscapeKeyDown
        maxWidth="sm"
        fullWidth
        BackdropProps={{
          sx: {
            backgroundColor: "rgba(0, 0, 0, 0.1)",
          },
        }}
        PaperProps={{
          sx: {
            borderRadius: "12px",
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
          },
        }}
      >
        <LinearProgress />
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "40px 24px",
            gap: "20px",
          }}
        >
          {text && (
            <Typography
              variant="body1"
              component="div"
              color="textSecondary"
              sx={{
                textAlign: "center",
                fontWeight: 500,
                fontSize: "16px",
              }}
            >
              {text}
            </Typography>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default CustomProgressDialog;
